<template>
  <!--begin::Chat-->
  <div class="d-flex flex-row">
    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8" id="kt_chat_content">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <!-- <div class="card-header align-items-center px-4 py-3"></div> -->

        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body">
          <div>
            <b-row>
              <div class="col-md-6">
                <b-form-group
                  id="input-group-2"
                  label="عنوان تیکت"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="ticket.subject"
                    :disabled="true"
                    placeholder="عنوان تیکت"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="وضعیت">
                  <b-form-input
                    v-model="ticket.status_name"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-row>
            <b-row>
              <div class="col-md-4">
                <b-form-group label="تاریخ ثبت">
                  <b-form-input
                    v-model="ticket.created_at"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4 col-sm-6">
                <b-form-group label="اهمیت">
                  <b-form-input
                    v-model="ticket.periority_name"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4 col-sm-6">
                <b-form-group label="دپارتمان">
                  <b-form-input
                    v-model="ticket.departments_name"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-button href="/tickets" class="ml-3" variant="danger"
                  >بازگشت</b-button
                >
                <b-button class="ml-3" variant="warning" @click="ticket.status_name!='بسته شده'? $bvModal.show('modal-1') : $makeToast('danger','عدم ارسال تیکت',`به دلیل بسته بودن وضعیت تیکت شما قادر به ارسال تیکت نمی باشید.`,5000)"
                  >ارسال پاسخ</b-button
                >
              </b-col>
            </b-row>
          </div>
          <hr />
          <!--begin::Scroll-->
          <div class="scroll scroll-pull mt-6" data-mobile-height="350">
            <!--begin::Messages-->
            <div class="messages">
              <div v-for="item in ticket.ticket_contents" v-bind:key="item.id">
                <div
                  v-if="!item.IsAdmin"
                  class="d-flex flex-column mb-12 align-items-start"
                >
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-circle symbol-40 mr-3">
                      <img alt="Pic" v-bind:src="item.image" />
                    </div>
                    <div>
                      <a
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-h6"
                        >{{ item.fullName }}</a
                      >
                      &nbsp;
                      <span class="text-muted font-size-sm">{{
                        item.time
                      }} </span>
                      <span class="text-muted font-size-sm ml-2"> {{
                        item.created_at.date
                      }}</span>
                    </div>
                  </div>
                  <div
                    style="white-space: pre-line"
                    class="mt-2 rounded p-5 bg-light-success text-dark-50 font-weight-bold font-size-lg text-left max-w-1000px"
                  >
                    {{ item.text }}
                    <div class="attach-content" v-if="item.files.length">
                      <b-link
                        class="attach-css"
                        target="_blank"
                        v-for="(file, index) in item.files"
                        :key="index"
                        v-bind:href="
                          'http://api.shepa.com/api/file/' + file.file_id
                        "
                        >&nbsp;&nbsp;&nbsp;&nbsp; دانلود فایل پیوست
                        {{ index + 1 }}</b-link
                      >
                    </div>
                  </div>
                </div>

                <div
                  v-if="item.IsAdmin"
                  class="d-flex flex-column mb-5 align-items-end"
                >
                  <div class="d-flex align-items-center">
                    <div>
                      <span class="text-muted font-size-sm mr-1">{{
                        item.created_at.date
                      }}</span>
                      <a
                        href="#"
                        class="text-dark-75 text-hover-primary font-weight-bold font-size-h6 mr-3"
                        >{{ item.fullName }}</a
                      >
                    </div>
                    <div class="symbol symbol-35 symbol-light-success">
                      <img alt="Pic" :src="item.image" />
                    </div>
                  </div>
                  <div
                    style="white-space: pre-line"
                    class="mt-2 rounded p-5 bg-light-primary text-dark-50 font-weight-bold font-size-lg text-left max-w-1000px"
                  >
                    {{ item.text }}
                    <div class="attach-content" v-if="item.files.length">
                      <b-link
                        class="attach-css"
                        target="_blank"
                        v-for="(file, index) in item.files"
                        :key="index"
                        v-bind:href="
                          'http://api.shepa.com/api/file/' + file.file_id
                        "
                        >&nbsp;&nbsp;&nbsp;&nbsp; دانلود فایل پیوست
                        {{ index + 1 }}</b-link
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--end::Messages-->
          </div>
          <!--end::Scroll-->
        </div>
        <!--end::Body-->
        <!--begin::Footer-->
        <!-- <div class="card-footer align-items-center">
          <textarea
            class="form-control border-0 p-0"
            rows="2"
            placeholder="Type a message"
          ></textarea>
          <div class="d-flex align-items-center justify-content-between mt-5">
            <div class="mr-3">
              <a href="#" class="btn btn-clean btn-icon btn-md mr-1">
                <i class="flaticon2-photograph icon-lg"></i>
              </a>
              <a href="#" class="btn btn-clean btn-icon btn-md">
                <i class="flaticon2-photo-camera icon-lg"></i>
              </a>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-primary btn-md text-uppercase font-weight-bold chat-send py-2 px-6"
              >
                Send
              </button>
            </div>
          </div>
        </div> -->
        <!--end::Footer-->
      </div>
      <!--end::Card-->
    </div>
    <!--end::Content-->
    <b-modal
      size="lg"
      id="modal-1"
      title="ارسال پاسخ"
      @ok="SendAnswer()"
      ok-title="ارسال"
      cancel-title="انصراف"
      @click="cancel"
    >
      <b-form-group id="input-group-8" label="متن پاسخ" label-for="input-8">
        <b-form-textarea
          id="input-8"
          v-model="ticket.text"
          rows="6"
          placeholder="متن پاسخ"
        ></b-form-textarea>
      </b-form-group>
      <b-row>
       
          <div
            class="col-md-3 mt-3"
            v-for="(x, index) in ticket.files"
            v-bind:key="x.file_id"
          >
            <!-- <b-img :src="'https://api.shepa.com/api/file/' + x.file_id" fluid></b-img> -->
            <b-button class="mr-5" @click="delete_attachment(index)" size="sm">
              <b-icon icon="trash"></b-icon>
            </b-button>
            <a
              target="_blank"
              :href="'https://api.shepa.com/api/file/' + x.file_id"
              >پیوست شماره {{ index + 1 }}</a
            >
          </div>
        
       
      </b-row>
      <b-row>
         <b-col class="col-md-4 mt-3">
          <b-form-group
            id="input-group-4"
            label="اضافه کردن پیوست: "
            label-for="input-4"
          >
            <fileUploader
              v-model="file"
              v-bind:fileUploaded="fileUploaded"
            ></fileUploader>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
  <!--end::Chat-->
</template>
<style>
.attach-css {
  display: inline-block;
  margin-right: 10px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelpoer from "@/helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
import fileUploader from "../../components/fileUploader";
export default {
  name: "TicketContent",
  data: function () {
    return {
      file: null,
      ticket: {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        departments_name: "",
        status_name: "",
        periority_name: "",
        files: [],
      },
      departments: [],
    };
  },
  components: {
    MDDropdown,
    fileUploader,
  },
  created() {
    this.$route.query.ticket==='new' ? this.$makeToast('success','ثبت موفق',`تیکت با موفقیت ثبت گردید.`,5000) : false;
  },
  methods: {
    fileUploaded: function () {
      if (!this.ticket.files) {
        this.ticket.files = [];
      }
      this.ticket.files.push({ file_id: this.file });
      this.file = "";
    },
    SendAnswer: function () {
       this.ticket.mdid1_status = 1;
      httpHelpoer.postData("tickets", this.ticket).then((res) => {
        if (res.success) {
          this.$makeToast('success','ثبت موفق',"اطلاعات شما با موفقیت تغییر یافت.",5000);
        }
        this.Loaded();
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.ticket.text = null;
      httpHelpoer.postData("tickets", this.ticket).then((res) => {
        if (res.success) {
          this.$makeToast('success','ثبت موفق',"اطلاعات شما با موفقیت تغییر یافت.",5000);
        }
        this.Loaded();
      });
    },
    delete_attachment(index) {
      this.ticket.files.splice(index, 1);
    },
    Loaded: function () {
      this.ticket = {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        ticket_contents: [],
        departments_name: "",
        files: [],
      };
      httpHelpoer.getData("tickets?id=" + this.$route.params.id).then((res) => {
        this.$root.$emit("refresh_menu", []);
        this.ticket.id = this.$route.params.id;
        this.ticket.subject = res.result.subject;
        this.ticket.department_id = res.result.department_id;
        this.ticket.departments_name = res.result.ticket_departments.name;
        this.ticket.mdid2_periority = res.result.mdid2_periority;
        this.ticket.periority_name = res.result.ticket_periority.title;
        this.ticket.mdid1_status = res.result.mdid1_status;
        this.ticket.status_name = res.result.ticket_status.title;
        this.ticket.created_at = persianDate.getDate(res.result.created_at);
        this.ticket.ticket_contents = res.result.ticket_contents.map(
          (element) => {
            return {
              IsAdmin: element.IsAdmin,
              text: element.text,
              fullName: element.fullName,
              created_at: persianDate.CalcDate(element.created_at),
              time: persianDate.getTime(element.created_at),
              files: element.files,
              image:
                element.image == "media/users/default.jpg"
                  ? "/media/users/default.jpg"
                  : "http://api.shepa.com/api/file/" + element.image,
            };
          }
        );
      });
    },
    cancel(){
      console.log("hi");
      this.ticket= {
        subject: "",
        text: "",
        department_id: 0,
        mdid2_periority: 0,
        mdid1_status: 0,
        departments_name: "",
        status_name: "",
        periority_name: "",
        files: [],
      }
    }
  },
  mounted() {
    this.Loaded();
    httpHelpoer.getData("departments").then((res) => {
      this.departments = res.result.map((element) => {
        return {
          value: element.id,
          text: element.name,
        };
      });
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "تیکت ها", route: "/tickets" },
      { title: "جزییات تیکت" },
    ]);
  },
};
</script>
